import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { Select } from "@mui/material";
import dayjs from "dayjs";
import { useState } from "react";
import { TextField, Button, MenuItem } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { ApiManager } from "../Services/Networking";
import Layout from "../Components/Layout";

export default function HolidayForm() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const isEdit = !!state?.holiday;
  const fullList = state?.fullList || [];

  const [formData, setFormData] = useState({
    name: state?.holiday?.name || "",
    from_date: state?.holiday
      ? dayjs(state.holiday.from_date).format("YYYY-MM-DD")
      : "",
    to_date: state?.holiday
      ? dayjs(state.holiday.to_date).format("YYYY-MM-DD")
      : "",
    holiday_type: state?.holiday?.holiday_type || "",
  });

  const handleSave = async () => {
    const res = isEdit
      ? await ApiManager.updateHoliday(state.holiday.id, formData)
      : await ApiManager.createHoliday(formData);

    if (res.status === "success") {
      let updatedList;
      if (isEdit) {
        updatedList = fullList.map((h) =>
          h.id === state.holiday.id ? res.data : h,
        );
      } else {
        updatedList = [...fullList, res.data];
      }
      navigate("/holiday", { state: { updatedList } });
    }
  };

  return (
    <Layout name={isEdit ? "EDIT HOLIDAY" : "ADD HOLIDAY"}>
      <Box sx={{ p: 3, maxWidth: "md" }}>
        <Stack direction="row" justifyContent="flex-end" spacing={2} mb={4}>
          <Button
            onClick={() =>
              navigate("/holiday", { state: { updatedList: fullList } })
            }
          >
            Cancel
          </Button>
          <Button variant="contained" onClick={handleSave}>
            {isEdit ? "Update" : "Save"}
          </Button>
        </Stack>

        <Grid container spacing={3}>
          <Grid size={12}>
            <Typography variant="body2" mb={1}>
              Holiday Name
            </Typography>
            <TextField
              fullWidth
              size="small"
              value={formData.name}
              onChange={(e) =>
                setFormData({ ...formData, name: e.target.value })
              }
            />
          </Grid>

          <Grid size={6}>
            <Typography variant="body2" mb={1}>
              Date From
            </Typography>
            <TextField
              fullWidth
              type="date"
              size="small"
              value={formData.from_date}
              onChange={(e) =>
                setFormData({ ...formData, from_date: e.target.value })
              }
            />
          </Grid>

          <Grid size={6}>
            <Typography variant="body2" mb={1}>
              Date To
            </Typography>
            <TextField
              fullWidth
              type="date"
              size="small"
              value={formData.to_date}
              onChange={(e) =>
                setFormData({ ...formData, to_date: e.target.value })
              }
            />
          </Grid>

          <Grid size={12}>
            <Typography variant="body2" mb={1}>
              Holiday Type
            </Typography>
            <Select
              fullWidth
              size="small"
              value={formData.holiday_type}
              onChange={(e) =>
                setFormData({ ...formData, holiday_type: e.target.value })
              }
            >
              <MenuItem value="National">National</MenuItem>
              <MenuItem value="Public">Public Holiday</MenuItem>
              <MenuItem value="Company">Company Holiday</MenuItem>
            </Select>
          </Grid>
        </Grid>
      </Box>
    </Layout>
  );
}
